module.exports = __webpack_public_path__ + "static/media/Test16.1765b110.bmp";